import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Client from '@/views/Client'
import Login from '@/views/pages/Login'
import ClientOrder from '@/views/ClientOrder'
import Production from '@/views/Production'
import Commandes from '@/views/Commandes'
import Clients from '@/views/Clients'
import ClientEdit from '@/views/ClientEdit'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/client',
      name: 'Home',
      component: Full,
      meta: { auth: true, label: 'Accueil' },
      children: [
        {
          path: '/client',
          name: 'Client',
          component: Client,
          meta: { auth: true }
        },
        {
          path: '/order/:id/:orderid',
          name: 'Commande client',
          meta: { auth: true },
          component: ClientOrder
        },
        {
          path: '/production',
          name: 'Liste des items à produire',
          meta: { auth: true },
          component: Production
        },
        {
          path: '/listing',
          name: 'Liste des commandes',
          meta: { auth: true },
          component: Commandes
        },
        {
          path: '/clients',
          name: 'Liste des clients',
          meta: { auth: true },
          component: Clients
        },
        {
          path: '/client-edit/:id',
          name: 'Edition de client',
          meta: { auth: true },
          component: ClientEdit
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { auth: false }
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: (to, from, next) => {
        var v = new Vue()
        v.$eventHub.$emit('redirectToLogin')
        next(false)
      },
      meta: { auth: false }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js